export default "__VITE_ASSET__Cv2PC2uf__"